/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlatformApiResultOfUserAccountDto } from '../../models/platform-api-result-of-user-account-dto';
import { PlatformDeactivateUserAccount } from '../../models/platform-deactivate-user-account';

export interface PostUseraccountsActionDeactivate$Params {
      body: PlatformDeactivateUserAccount
}

export function postUseraccountsActionDeactivate(http: HttpClient, rootUrl: string, params: PostUseraccountsActionDeactivate$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfUserAccountDto>> {
  const rb = new RequestBuilder(rootUrl, postUseraccountsActionDeactivate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlatformApiResultOfUserAccountDto>;
    })
  );
}

postUseraccountsActionDeactivate.PATH = '/api/useraccounts/action/deactivate';
